import { render, staticRenderFns } from "./BatchProperties.vue?vue&type=template&id=73305e3c&scoped=true&"
import script from "./BatchProperties.vue?vue&type=script&lang=js&"
export * from "./BatchProperties.vue?vue&type=script&lang=js&"
import style0 from "./BatchProperties.vue?vue&type=style&index=0&id=73305e3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73305e3c",
  null
  
)

export default component.exports